export const scrollToUrlListener = () => {
    const selector = new URLSearchParams(window.location.search).get('scroll_to');

    if (!selector) {
        return;
    }

    const elementToScrollTo = document.querySelector(`#${selector}`);

    elementToScrollTo?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
    });
};
